<template>
  <teleport :to="'#galleryModalTeleport'">
    <div 
      class="DocumentElementGalleryModal w-screen flex justify-center overflow-y-scroll"
      @click="collapseHandler"
      ref="DocumentElementGalleryModal"
    >
      <div class="fixed z-10 top-0 left-0 right-0 flex h-10 justify-between items-center px-4 bg-gray-800 text-white">
        <span>
          {{ modalTitle }}
        </span>
        <div class="flex items-center space-x-5">
          <slot 
            name="select"
          />
          <right-menu-item-share
            v-if="!isSharedDocument"
            :is-gallery-modal="true"
            :shared-items="images"
          />
          <right-menu-item-add-share-list 
            v-if="!isSharedDocument"
            :is-gallery-modal="true"
            :shared-items="images"
          />
          <right-menu-item-download
            :is-gallery-modal="true"
          />
          <right-menu-item-download-pdf 
            v-if="!isSharedDocument"
            :is-gallery-modal="true"
            :shared-items="images"
          />
          <button 
            type="button" 
            class="text-gray-500  hover:text-gray-200"
            @click="$emit('collapse-gallery-modal')"
          >
            <aw-icon
              icon="close"
              class="w-5 h-5"
            />
          </button>
        </div>
      </div>
      <div class="DocumentElementGalleryModal__Content relative flex w-max flex-row flex-wrap bg-bc-gray-bg p-7 justify-start content-start mb-32">
        <slot />
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  emits: ['collapse-gallery-modal'],
  props: {
    images: {
      type: Array
    }
  },
  computed: {
    modalTitle() {
      return this.images.length + this.$t(' fotek')
    },
    isSharedDocument() {
      return this.$route.matched[0].name === 'BCSharedDocument'
    },
  },
  methods: {
    collapseHandler(e) {
      if (e.target.contains(this.$refs.DocumentElementGalleryModal)) {
        this.$emit('collapse-gallery-modal')
      }
    },
    eventHandler(e) {
      if (e.key === 'Escape' && !this.$route.query.gallery) {
        this.$emit('collapse-gallery-modal')
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.eventHandler)
  },
  unmounted() {
    document.removeEventListener('keydown', this.eventHandler)
  }
}
</script>

<style lang="scss">
.DocumentElementGalleryModalWrapper {
  z-index: 102;
  top: 2.5rem;
}

.DocumentElementGalleryModal {
  z-index: 102;
  background: rgba(#000, 0.75);
  height: calc(100vh - 2.5rem);
}

.DocumentElementGalleryModal__Content {
  height: fit-content;
  min-height: calc(100vh - 12rem);

  @screen lg {
    min-height: calc(100vh - 16.25rem);
  }
}
</style>
